import * as React from 'react';
import { observer } from 'mobx-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import { copyLink } from 'owa-calendar-sharing/lib/utils/copyLink';
import getPublishedUrl from '../selectors/getPublishedUrl';
import getPublishedStatus from '../selectors/getPublishedStatus';
import { getMailPath } from 'owa-url';
import { Link } from 'office-ui-fabric-react/lib/Link';

const styles = require('./SharePbpSection.scss');

export default observer(function SharePbpFull() {
    const onCopyLink = () => {
        copyLink(publishedUrl);
    };

    const onShareLink = () => {
        let subject = strings.options_pbp_sharePbpSubject;
        let body = strings.options_pbp_sharePbpBody + '\n\n' + publishedUrl;
        window.open(
            `${getMailPath()}deeplink/compose?subject=${encodeURIComponent(
                subject
            )}&body=${encodeURIComponent(body)}`,
            'sharePbp',
            'height=640,width=1095'
        );
    };

    let publishedUrl = getPublishedUrl();

    return (
        <div>
            {getPublishedStatus() && (
                <div>
                    <div>{strings.options_pbp_bookingPageLink} </div>

                    <Link target={'_blank'} href={publishedUrl}>
                        {publishedUrl}
                    </Link>

                    <div className={styles.SharePbpSection}>
                        <DefaultButton
                            primary={false}
                            disabled={false}
                            text={strings.options_pbp_copyLinkButton}
                            className={styles.copyButton}
                            onClick={onCopyLink}
                        />

                        <DefaultButton
                            primary={false}
                            disabled={false}
                            text={strings.options_pbp_shareLinkButton}
                            className={styles.shareButton}
                            onClick={onShareLink}
                        />
                    </div>
                </div>
            )}
            {!getPublishedStatus() && strings.options_pbp_bookingPageNotPublishedLabel}
        </div>
    );
});
